export const exec = async (getter: any) => {
    return await getter()
}
